// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import Mint from 'mint-ui';

import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '../theme/index.css'

import 'mint-ui/lib/style.css';
import '@/assets/css/base.css';
import '@/assets/css/index.css';

import App from './App.vue';
import store from './store/store'
import router from './router'
import axios from './axios/axios'

import {formatCurrency} from "./util/formatCurrency";
import {apiPath} from "./util/global"

import Navigation from 'vue-navigation'
// import vueFrozen from 'vue-frozen'
import 'babel-polyfill'
import Meta from 'vue-meta'
import {getCookie} from "./util/util";
import httpRequest from '@/util/httpRequest'
// Vue.use(vueFrozen);
Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.use(Mint);

// Vue.use(Navigation, {router,store,moduleName: 'navigation',keyName: 'zhiyi'})

Vue.use(Meta)

//定义过滤器
Vue.filter("FormatCurrency",formatCurrency);

//enterNumber
Vue.directive('enterNumber', {
  inserted: function (el) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
        if(e.preventDefault){
          e.preventDefault();
        }else{
          e.returnValue = false;
        }
      }
    });
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requireAuth)){  // 判断该路由是否需要登录权限
//     if (getCookie("_token")) {  // 判断当前的token是否存在
//       next();
//     } else {
//       Vue.prototype.$message({
//         type:'error',
//         message:'登录信息失效,请重新登录'
//       });
//       next({ path: '/' })
//     }
//   } else {
//     next();
//   }
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js